<!--
  创建时间：2023/7/28 17:10
  创建人：toyehuang
  文件描述：LayoutFooter
-->

<template>
  <footer class="layout-footer mt-30">
    <div class="footer-container fc99">
      <div class="def-w f-b-c">
        <div class="row">
          <dl>
            <dt>联系我们</dt>
            <dd>联系电话：{{ site.consultHotline }}</dd>
            <dd>地址：{{ site.address }} </dd>
          </dl>
          <dl>
            <dt>技术支持</dt>
            <dd>技术支持：江苏易交易信息科技有限公司</dd>
            <dd>电话：{{ site.technicalHotline }}</dd>
            <dd>地址：江苏省常州市钟楼区玉龙南路280号常州大数据产业园4号楼21层</dd>
          </dl>
        </div>
        <div class="wx-qrcode">
          <img :src="site.wechatLogo" :alt="site.name">
          <p>关注微信公众号</p>
        </div>
      </div>
    </div>
    <div class="site-info fc99 bgff flex-column-center">
      <p>
        Copyright 2021 All Rights Reserved 长沙联合产权交易所阳光采购平台 版权所有 湘ICP备19019540号
      </p>
      <p>
        地址：湖南省长沙市芙蓉区马王堆中路248号 技术支持：长沙市网络传媒有限公司
      </p>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getConstantDic,
  INFO_TYPE_OPTIONS,
  PROJECT_TYPE_OPTIONS,
  SELECT_OPTION_CONFIG
} from "@/utils/constant";
export default {
  name: "LayoutFooter",
  data() {
    return {
      projectTypeOpt: getConstantDic(PROJECT_TYPE_OPTIONS).filter(
        (item) =>
          item[SELECT_OPTION_CONFIG.CODE] !==
          PROJECT_TYPE_OPTIONS.ALL[SELECT_OPTION_CONFIG.CODE]
      ),
      infoTypeOpt: getConstantDic(INFO_TYPE_OPTIONS).filter(
        (item) =>
          item[SELECT_OPTION_CONFIG.CODE] !==
          INFO_TYPE_OPTIONS.ALL[SELECT_OPTION_CONFIG.CODE]
      ),
      SELECT_OPTION_CONFIG
    };
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapGetters(["site", "allMenusTree"])
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  // 方法集合
  methods: {
  }
};
</script>

<style scoped lang="scss">
.layout-footer {
  .footer-container{
    height: 320px;
    padding-top: 50px;
    background-color: #333;
    dl{
      min-width: 450px;
      padding-right: 20px;
      line-height: 36px;
      dt{
        color: #fff;
        font-size: 20px;
        font-weight: bold;
      }
      dd{
        font-size: 14px;
      }
    }
    .wx-qrcode{
      text-align: center;
      font-size: 14px;
      img{
        width: 100px;
        height: 100px;
      }
    }
  }
  .site-info{
    width: 100%;
    height: 60px;
    text-align: center;
    font-size: 12px;
  }
}
</style>
